export default __webpack_public_path__ + "static/media/VALUES.1b3d6eba.png";